export default __webpack_public_path__ + "static/media/eye.435ce1f5.svg";